import React from "react";
import moment from "moment";
import {
	Card,
	CardContent,
	CardHeader,
	Typography,
	Grid,
	Theme,
	Grow,
	Popover,
	Avatar,
	Box
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
// import CompleteProgressBar from "./CompleteProgressBar";
import { useTranslation, Trans } from "react-i18next";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { connect } from "react-redux";
import capitalize from "../../helpers/Capitalize";

const defaultUser = {
	avatar: require("../../media/me.jpg"),
	city: "Seattle",
	country: "USA",
	jobTitle: "Senior Developer",
	name: "John Doe",
	beltLevel: "Black Belt",
	since: "Feb 2, 2022",
	memberID: "#987645"
};

interface Items {
	title: string;
	amount: any;
	key: any;
	delay: any;
}

const itemsList: Items[] = [
	{ title: "Classes Taken", amount: "8", key: "1", delay: 2000 },
	{ title: "Classes Remaining", amount: "14", key: "2", delay: 3000 },
	{ title: "Classes Purchased", amount: "28", key: "3", delay: 4000 },
];

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		marginBottom: "20px",
	},
	avatar: {
		height: 100,
		width: 100,
		marginLeft: "auto",
		marginRight: "auto",

		marginBottom: 10,
	},
	paper: {
		position: "absolute",
		width: 300,
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(0, 2, 3),
		marginLeft: "auto",
		marginRight: "auto",
	},
	buttonPadding: {
		margin: "0px",
	},
	cardHeader: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		alignItems: "center",
		textAlign: "center",
	},
	button: {
		backgroundColor: theme.palette.primary.main,
		width: "100%",
		color: "white",
		alignItems: "center",
		borderRadius: 5,
		padding: 10,
		margin: 5,
		minWidth: 70,
	},
	padding: {
		paddingRight: 0,

	},
	popover: {
		pointerEvents: "none",
	},
	message: {
		padding: 10,
		marginBottom: 0,
		paddingBottom: 0,
	},
}));

const Profile = (props: any) => {
	const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
	const classes = useStyles();
	useTranslation();

	const handlePopoverOpen = (
		event: React.MouseEvent<HTMLElement, MouseEvent>
	) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};
	const open = Boolean(anchorEl);

	return (
		<div className={classes.padding}>
			<Grow in={true} timeout={1500}>
				<Card raised={true} className={classes.root}>
					<CardHeader
						className={classes.cardHeader}
						title={<Trans>Profile</Trans>}
					/>

					<CardContent>
						<Grid container>
							<Grid style={{ paddingLeft: 10 }} item xs={5}>
								<Avatar className={classes.avatar} src={defaultUser.avatar} />
								{/* <Typography
										color="textPrimary"
										variant="subtitle1"
										align="center"
										style={{ lineHeight: 1.25 }}
									>
										{user
											? capitalize(user.firstName) +
											  " " +
											  capitalize(user.lastName)
											: defaultUser.name}
									</Typography> */}
							</Grid>
							<Grid
								justifyContent="center"
								style={{ marginTop: 5, paddingLeft: 1, textAlign: "center" }}
								item
								xs={6}
							>

								<Typography
									color="primary.contrastText"
									variant="subtitle2"
									align="left"
									style={{ lineHeight: 1.25 }}
								>
									<span style={{ color: "#1976D2" }}><strong>Member Name:</strong></span><br />
									{defaultUser.name}
								</Typography>
								<Typography
									color="primary.contrastText"
									variant="subtitle2"
									align="left"
								>
									<span style={{ color: "#1976D2" }}><strong>Member ID:</strong></span><br />
									{defaultUser.memberID}
								</Typography>

								{/* <strong>
										<Trans>Member Since</Trans>:
									</strong>
									<br />
									{defaultUser.since} */}

								{/* <Typography align="left" color="primary" variant="body2">
										<strong>
											<Trans>Belt Level</Trans>:
										</strong>
										<Trans> {defaultUser.beltLevel}</Trans>
									</Typography>
									<Typography align="left" color="primary" variant="body2">
										<strong>
											<Trans>Profile Completion</Trans>:
										</strong>
									</Typography> */}
								{/* <div style={{ maxWidth: 170 }}>
										<CompleteProgressBar />
									</div> */}
							</Grid>
						</Grid>
						<Typography
							style={{ marginTop: 10, marginBottom: 10 }}
							align="center"
							variant="body2"
							color="secondary"
						>
							<strong>
								<Trans>This Month at a Glance</Trans>
							</strong>
						</Typography>
						<Grid container justifyContent="center">
							{itemsList.map((item: any) => (
								<Grow key={item.title} in={true} timeout={item.delay}>
									<Grid item xs={3.5} sm={3} className={classes.button}>
										<Typography color="secondary" align="center" variant="body2">
											<Trans>{item.title}</Trans>
										</Typography>
										<Typography align="center" variant="h3">
											{item.amount}
										</Typography>
									</Grid>
								</Grow>
							))}
						</Grid>
					</CardContent>
				</Card>
			</Grow>
		</div>
	);
};


export default Profile;
